import { Get } from "../utils/http-utils";

export const getAuditLogsForDevice = async (queryParams) => {
    
    return Get("/auditlogs", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const getGlobalAuditLogs = async (queryParams) => {
    return Get("/auditlogs", queryParams)
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};

export const getGlobalAuditFilters = async () => {
    return Get("/auditlogs-filters")
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return [];
        });
};
